export default "__VITE_ASSET__Dx9B0vRq__"